import { IdentificationState } from '@sanlam-glacier/app-common/types/auth/identification-state.type.js';
import { TokenResponse } from '@sanlam-glacier/app-common/types/auth/token-response.type.js';
import { UserInfo } from '@sanlam-glacier/app-common/types/auth/user-info.type.js';
import { Env } from '@sanlam-glacier/app-common/types/env/Env.type.js';
import { AuthStore } from 'auth/storage/auth-storage-manager';

export const getInitialIdentificationState = (env: Env): IdentificationState => {
  const userInfo = AuthStore.getUserInfo();
  const token = AuthStore.getAuthToken();
  const isUserInStorageValid = userInfo && token && token.token_expiry_time > new Date();
  if (isUserInStorageValid) return 'authenticated';
  return 'unidentified';
};

export const getInitialSignedInUser = (): UserInfo | undefined => {
  const userInfo = AuthStore.getUserInfo();
  const token = AuthStore.getAuthToken();
  if (!userInfo || !token || token.token_expiry_time < new Date()) return undefined;
  return userInfo;
};

export const getInitialToken = (): TokenResponse | undefined => {
  const token = AuthStore.getAuthToken();
  if (token && token.token_expiry_time > new Date()) return token;
  return undefined;
};
